let Categories = [
  "Traditional Craftspeople",
  "Street Vendors",
  "Self-Help Groups",
  "Disabled",
  "Skill-Less Labor",
  "Agricultural Producers",
  "Women",
];

export default Categories;
